import type { ReactNode } from 'react'
import type { AuthSignInContext, AuthSignInFormSlot } from './types'

export function renderSlot<TContext>(
  slot:
    | ReactNode
    | ((ctx: TContext) => ReactNode)
    | null
    | false
    | undefined,
  defaultNode: () => ReactNode,
  ctx: TContext
): ReactNode {
  if (slot === false || slot === null) return null
  if (typeof slot === 'function') return slot(ctx)
  if (slot !== undefined) return slot
  return defaultNode()
}

export function renderAuthSlot(
  slot: AuthSignInFormSlot | undefined,
  defaultNode: () => ReactNode,
  ctx: AuthSignInContext
): ReactNode {
  return renderSlot(slot, defaultNode, ctx)
}
